import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ButtonV2 from '../Button/ButtonV2';

import './ReadyWhenYouAre.css';

export const ReadyWhenYouAre = ({
  component: Component = 'section',
  titleElement: TitleElement = 'div',
  className,
  onClick,
  text = (
    <>
      <span className="ready-when-you-are__title--ready">Ready&nbsp;</span>When You Are
    </>
  ),
  buttonText = 'Start Your Registry',
  link,
  ...props
}) => {
  const classes = cx('ready-when-you-are', className);
  return (
    <Component className={classes} {...props}>
      <TitleElement className="ready-when-you-are__title">{text}</TitleElement>
      <ButtonV2 bordered component="a" variant="primary" onClick={onClick} href={link}>
        {buttonText}
      </ButtonV2>
    </Component>
  );
};

ReadyWhenYouAre.propTypes = {
  buttonText: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  titleElement: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  component: PropTypes.oneOf(['section', 'div']),
  link: PropTypes.string,
};

export default ReadyWhenYouAre;
